module.exports = __webpack_public_path__ + "media/images/plus-250f24f2204f589287b4b987dbcd6f0a.svg";